import localforage from "localforage";

import pkg from "../../package.json";

export function initializeLocalForage() {
  localforage.config({
    name: pkg.name,
    version: parseInt(pkg.version.split(".")[0]),
    description: `${pkg.name}-${pkg.version}`,
  });
}

export function read<T>(key: string): Promise<T | null> {
  return localforage.getItem(key);
}

let debounce: NodeJS.Timeout;
export function write<T>(key: string, value: T): void {
  clearTimeout(debounce);
  debounce = setTimeout(() => localforage.setItem(key, value), 1000);
}
